import * as React from 'react';
import Icon from '@mui/material/Icon';

export interface FontIconProps {
  value?: string;
  alt?: string;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  id?: string;
  onClick?: React.MouseEventHandler<HTMLSpanElement>;
}

/**
 * FontIcon wrapper - maps react-toolbox FontIcon to MUI Icon
 * - `value` prop maps to children (the icon name)
 * - Passes through className and other HTML attributes
 */
const FontIcon = React.forwardRef<HTMLSpanElement, FontIconProps>(
  ({ value, alt, children, className, style, id, onClick }, ref) => {
    const iconName = value || children;

    if (!iconName) {
      return null;
    }

    return (
      <Icon ref={ref} className={className} style={style} id={id} aria-label={alt} onClick={onClick}>
        {iconName}
      </Icon>
    );
  },
);

FontIcon.displayName = 'FontIcon';

export default FontIcon;
